"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectMulti = void 0;
var react_1 = __importStar(require("react"));
var useFormControl_1 = require("../../../hooks/useFormControl");
var Checkbox_1 = require("../../Checkbox/Checkbox");
var FormControl_1 = require("../../FormControl");
var HFlow_1 = require("../../HFlow");
var SelectDownshiftMenu_1 = require("../SelectSingle/SelectDownshiftMenu");
var MultiDownshift_1 = require("./MultiDownshift");
var SelectMultiInput_1 = require("./SelectMultiInput");
function SelectMulti(props) {
    var value = props.value, items = props.items, itemToString = props.itemToString, onChange = props.onChange, isOpen = props.isOpen, itemIsEqual = props.itemIsEqual, onFilterChange = props.onFilterChange, loading = props.loading, externalRenderItem = props.renderItem, components = props.components, popperProps = props.popperProps, placeholder = props.placeholder, label = props.label, error = props.error, rest = __rest(props, ["value", "items", "itemToString", "onChange", "isOpen", "itemIsEqual", "onFilterChange", "loading", "renderItem", "components", "popperProps", "placeholder", "label", "error"]);
    var inputWrapperRef = react_1.useRef();
    var handleItemRemove = function (removeItem) { return function (item) { return removeItem(item); }; };
    var renderItem = function (_a) {
        var isSelected = _a.isSelected;
        return function (item) { return (react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 0.5, alignItems: 'center' },
            react_1.default.createElement(Checkbox_1.Checkbox, { style: { pointerEvents: 'none' }, checked: isSelected(item), tabIndex: -1, readOnly: true }),
            externalRenderItem ? externalRenderItem(item) : itemToString(item))); };
    };
    //   const handleInputIconClick = ({ toggleMenu }: MultiSelectRenderProps<T>) => () => toggleMenu()
    var handleInputClick = function (_a) {
        var openMenu = _a.openMenu;
        return function () { return openMenu(); };
    };
    var handleInputBlur = function (_a) {
        var closeMenu = _a.closeMenu;
        return function (e) {
            closeMenu();
            props.onBlur && props.onBlur(e);
        };
    };
    var handleInputFocus = function (_a) {
        var openMenu = _a.openMenu;
        return function (e) {
            openMenu();
            props.onFocus && props.onFocus(e);
        };
    };
    var _a = useFormControl_1.useFormControl(props), getFormControlProps = _a.getFormControlProps, getFormControlInputProps = _a.getInputProps;
    var formControlProps = getFormControlProps();
    var inputProps = getFormControlInputProps();
    var invalid = inputProps['aria-invalid'];
    return (react_1.default.createElement(FormControl_1.FormControl, __assign({}, formControlProps),
        react_1.default.createElement(MultiDownshift_1.MultiDownshift, { selectedItems: value || [], items: items, itemToString: itemToString, onChange: onChange, isOpen: isOpen, itemIsEqual: itemIsEqual, onFilterChange: onFilterChange, labelId: formControlProps.labelId }, function (downshift) {
            var 
            // isOpen,
            getInputProps = downshift.getInputProps, selectedItems = downshift.selectedItems, removeItem = downshift.removeItem, inputValue = downshift.inputValue, visibleItems = downshift.visibleItems;
            return (react_1.default.createElement("div", null,
                react_1.default.createElement(SelectMultiInput_1.SelectMultiInput, __assign({ wrapperRef: inputWrapperRef, items: selectedItems }, rest, { placeholder: !selectedItems || selectedItems.length === 0 ? placeholder : undefined, onClick: handleInputClick(downshift), onRemoveItem: handleItemRemove(removeItem), renderItem: itemToString }, getInputProps({
                    onBlur: handleInputBlur(downshift),
                    onFocus: handleInputFocus(downshift),
                }), inputProps, { value: inputValue ? inputValue : '', invalid: invalid })),
                react_1.default.createElement(SelectDownshiftMenu_1.SelectDownshiftMenu, { popperProps: popperProps, anchorRef: inputWrapperRef, downshift: downshift, items: visibleItems, loading: loading, components: components, renderItem: renderItem(downshift) })));
        })));
}
exports.SelectMulti = SelectMulti;
//# sourceMappingURL=SelectMulti.js.map